import * as yup from 'yup';

const FORGOT_PASSWORD_FIELDS_SCHEMA = yup.object().shape({
  email: yup.string().email().required(),
});

export default FORGOT_PASSWORD_FIELDS_SCHEMA;
